import {useContext} from 'react';
import {RouterReactContext} from './RouterReactContext';

export function useRouter() {
	const context = useContext(RouterReactContext);

	if (!context) {
		throw new Error('Router "useRouter": the router context is not provided');
	}

	return context;
}

useRouter.dispalyName = 'useRouter';
